import React from "react";
import { Route, Switch } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { Footer, Loading } from "./components";
import { Home, Profile, ExternalApi, PakuApp, CustomersReports } from "./views";
import ProtectedRoute from "./auth/protected-route";

import "./common/css/app.css";

const App = () => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return <Loading />;
  }

  console.log("                                               ");
  console.log("              Welcome to Paku App!             ");
  console.log("                                               ");

  console.log("          ▄████▄                 ▒▒▒▒▒         ");
  console.log("         ███▄█▀                 ▒ ▄▒ ▄▒        ");
  console.log("        ▐████  █  █  █  █  █  █ ▒▒▒▒▒▒▒        ");
  console.log("         █████▄                 ▒▒▒▒▒▒▒        ");
  console.log("          ▀████▀                ▒ ▒ ▒ ▒        ");
  console.log("\n");

  console.log(
    "I don't know what you're doing here ▒ ▄▒ ▄▒ but it's a \npleasure of course, happy hacking! \n\nIf you find an error, have suggestions, doubts or just \nyou want to say hi! write to us at: info@kinzbio.com."
  );
  console.log();
  console.log("\n");
  // console.log(
  //   "Maybe I can help you!, thinking better of it, I can't sorry I'm just a placeholder, what did you expect? :D, but if you have suggestions, doubts, or just want to say hi! write to us at: info@kinzbio.com "
  // );
  // console.log("\n");

  return (
    <div id="app" className="d-flex flex-column h-100">
      <div className="flex-grow-1">
        <Switch>
          <Route path="/" exact component={Home} />
          <ProtectedRoute path="/profile" component={Profile} />
          <ProtectedRoute path="/external-api" component={ExternalApi} />
          <ProtectedRoute path="/paku-app" component={PakuApp} />
          <ProtectedRoute
            path="/customers-reports"
            component={CustomersReports}
          />
        </Switch>
      </div>
      <Footer />
    </div>
  );
};

export default App;
